import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    contentHeaderToken: {
        marginTop: 2,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10
    },
    contentDescriptionToken: {
        marginTop: 20,
    },
    contentHeaderToken2:
    {
        marginTop: 20,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: "center",
        paddingHorizontal: 10
    },
    imgToken: {
        width: 62,
        height: 62
    },
    nameToken: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    priceToken: {
        marginTop: 20,
        fontWeight: 'bold',
        color: '#F49C16',
        fontSize: 18
    },
    titleCirculation: {
        fontSize: 10,
        fontWeight: 'bold',
        paddingVertical: 13
    },
    amountCirculation: {
        fontSize: 10,
        fontWeight: '400',
        marginTop: -4
    }
});

export default styles;
